import ContactForm from '../components/ContactForm'

const Contact = () => {
  const contactMethods = [
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      title: 'Email Support',
      description: 'Get help via email within 24 hours',
      contact: 'admin@unitradeinternational.com',
      action: 'Send Email'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
        </svg>
      ),
      title: 'Phone Support',
      description: 'Speak with our team during business hours',
      contact: '+1 (555) 123-4567',
      action: 'Call Now'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
      ),
      title: 'Live Chat',
      description: 'Chat with our support team 24/7',
      contact: 'Available 24/7',
      action: 'Start Chat'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      title: 'Office Locations',
      description: 'Visit our offices worldwide',
      contact: 'New York, London, Singapore',
      action: 'View Locations'
    }
  ]

  const offices = [
    {
      city: 'New York',
      address: '123 Wall Street, Suite 500',
      zipcode: 'New York, NY 10005',
      country: 'United States',
      phone: '+1 (555) 123-4567',
      hours: 'Mon-Fri: 9:00 AM - 6:00 PM EST'
    },
    {
      city: 'London',
      address: '45 Canary Wharf',
      zipcode: 'London E14 5AB',
      country: 'United Kingdom',
      phone: '+44 20 7123 4567',
      hours: 'Mon-Fri: 9:00 AM - 6:00 PM GMT'
    },
    {
      city: 'Singapore',
      address: '1 Raffles Place, #40-01',
      zipcode: 'Singapore 048616',
      country: 'Singapore',
      phone: '+65 6123 4567',
      hours: 'Mon-Fri: 9:00 AM - 6:00 PM SGT'
    }
  ]

  return (
    <div className="min-h-screen bg-neutral dark:bg-secondary">
      {/* Header */}
      <section className="bg-gradient-primary text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Get in Touch
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl">
            Have questions? Our team is here to help you trade with confidence.
          </p>
        </div>
      </section>

      {/* Contact Methods */}
      <section className="section-container bg-white dark:bg-secondary-light">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {contactMethods.map((method, index) => (
            <div key={index} className="card text-center hover:scale-105 transition-transform">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 text-primary flex items-center justify-center">
                {method.icon}
              </div>
              <h3 className="text-lg font-bold text-secondary dark:text-white mb-2">
                {method.title}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
                {method.description}
              </p>
              <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-4">
                {method.contact}
              </p>
              <button className="text-sm text-primary font-medium hover:underline">
                {method.action}
              </button>
            </div>
          ))}
        </div>

        {/* Contact Form */}
        <ContactForm />
      </section>

      {/* Office Locations */}
      <section className="section-container bg-neutral dark:bg-secondary">
        <h2 className="text-3xl md:text-4xl font-bold text-secondary dark:text-white mb-12 text-center">
          Our Global Offices
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {offices.map((office, index) => (
            <div key={index} className="card">
              <h3 className="text-2xl font-bold text-secondary dark:text-white mb-4">
                {office.city}
              </h3>
              <div className="space-y-3 text-gray-600 dark:text-gray-400">
                <div className="flex items-start">
                  <svg className="w-5 h-5 mr-2 mt-0.5 text-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <div>
                    <p>{office.address}</p>
                    <p>{office.zipcode}</p>
                    <p>{office.country}</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <svg className="w-5 h-5 mr-2 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <p>{office.phone}</p>
                </div>
                <div className="flex items-center">
                  <svg className="w-5 h-5 mr-2 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <p className="text-sm">{office.hours}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ Section */}
      <section className="section-container bg-white dark:bg-secondary-light">
        <h2 className="text-3xl md:text-4xl font-bold text-secondary dark:text-white mb-12 text-center">
          Frequently Asked Questions
        </h2>
        <div className="max-w-3xl mx-auto space-y-6">
          {[
            {
              q: 'How do I open an account?',
              a: 'Click "Get Started" to begin the registration process. You\'ll need a valid ID and can be trading within minutes after verification.'
            },
            {
              q: 'What are your trading fees?',
              a: 'We offer commission-free stock trading and competitive spreads on forex and crypto. Check our Services page for detailed pricing.'
            },
            {
              q: 'Is my money safe?',
              a: 'Yes. We use bank-grade security, cold storage for crypto assets, and are fully regulated. Customer funds are segregated and SIPC protected.'
            },
            {
              q: 'Do you offer a mobile app?',
              a: 'Yes! Our mobile app is available for iOS and Android with full trading functionality and real-time alerts.'
            }
          ].map((faq, index) => (
            <details key={index} className="card group">
              <summary className="font-semibold text-lg text-secondary dark:text-white cursor-pointer list-none flex justify-between items-center">
                {faq.q}
                <svg className="w-5 h-5 transform group-open:rotate-180 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </summary>
              <p className="mt-4 text-gray-600 dark:text-gray-400">
                {faq.a}
              </p>
            </details>
          ))}
        </div>
      </section>
    </div>
  )
}

export default Contact
